// extracted by mini-css-extract-plugin
export default {"container":"Partners_container__BEw4p","box":"Partners_box__-s0Py"};